import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components'
import previous from '../assets/previous.png'
import results from '../assets/results.png'

const Result = () => {
    const navigate = useNavigate();
    useEffect(() => {
        const timer = setTimeout(() => {
            navigate('/feedback', { replace: true });
        }, 5000);
        return () => clearTimeout(timer);
    }, [navigate]);

    return (
        <Container>
            <Previous to="/searchbyphoto" >Previous</Previous>
            <Image src={ results } alt={ results } />
        </Container>
    );
}

const Container = styled.div`
    width: 90%;
    padding-top: 50px;
    margin: 0 auto;
    text-align: center;
`
const Previous = styled(Link)`
    position: absolute;
    font-family: ContinentalBook;
    top: 95px;
    left: 5%;
    color: black;
    text-decoration: none;
    &:before {
        background-image: url(${previous});
        background-size: 7px 13px;
        display: inline-block;
        width: 7px; 
        height: 13px;
        content:"";
        margin-right: 13px;
    }
`
const Image = styled.img`
    width: 100%;
`
export default Result;